// O PREÇO QUE UM CLIENTE B2B PAGA POR UNIDADE — FONTE ÚNICA.
//
// Esta conta vivia só dentro do Catalogo.jsx. A 30/09/2026 o separador de
// preços de mercado precisou dela, e copiá-la para lá era pôr dois donos na
// mesma conta — foi assim que o preço de particular acabou a alternar de hora
// a hora. Saiu para aqui e os dois ecrãs passaram a chamá-la.
//
// As três regras que a compõem, e que só se percebem juntas:
//
//   1. PORTES COBRADOS estão embutidos no `Produtos.preco`, ao valor por
//      omissão. Um cliente com portes diferentes leva a diferença por cima —
//      nunca por baixo, daí o `Math.max(0, ...)`.
//
//   2. O DESCONTO DO PERFIL NÃO INCIDE SOBRE OS PORTES. Descontar os portes
//      era dar desconto sobre o que se paga ao transportador, e essa margem
//      (0,25 €/un) é fina de mais para se deixar comer.
//
//   3. HÁ FORNECEDORES QUE VENDEM A TABELA e não levam desconto nenhum
//      (`permite_desconto = false`). É por isso que a mesma encomenda leva
//      umas linhas com desconto e outras sem.
//
// Só trata do caso B2B. Particular e conta interna têm outras bases e ficam
// onde estão, no Catálogo, porque não há mais nenhum ecrã a precisar delas.

/**
 * @param produto   linha da Produtos (precisa de `preco` e `fornecedor_id`)
 * @param perfil    perfil do cliente (`desconto_percentagem`, `portes_por_unidade`)
 * @param fornecedor  linha de fornecedores desse produto, ou null
 * @param portesUn  portes cobrados por omissão (config_sistema.portes_por_unidade)
 */
export function precoUnitarioB2B({ produto, perfil, fornecedor, portesUn }) {
  const base0 = Number(produto?.preco)
  if (!Number.isFinite(base0)) return null

  const portesDoCliente = perfil?.portes_por_unidade != null
    ? Number(perfil.portes_por_unidade) : 1.00
  const portesDiff = Math.max(0, portesDoCliente - Number(portesUn || 0))
  const base = base0 + portesDiff

  const pct = fornecedor?.permite_desconto === false
    ? 0 : Number(perfil?.desconto_percentagem || 0)
  if (!(pct > 0)) return base

  const portesEmbutidos = fornecedor?.portes_cobrados_por_unidade != null
    ? Number(fornecedor.portes_cobrados_por_unidade) : Number(portesUn || 0)
  return base - Math.max(0, base - portesEmbutidos) * (pct / 100)
}
